import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_SURFACE = {
  Default: "default",
  Raised: "raised",
  Accent: "accent",
  Info: "info",
  Success: "success",
  Warning: "warning",
  Danger: "danger",
} as const;

export type DSSurface = ObjectValues<typeof DS_SURFACE>;
